import React, { Component } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
import { Card, Pagination, Container, Row, Col } from 'react-bootstrap'
import img18 from '../EquipoMedico/img18.jpg'
import img23 from '../EquipoMedico/img23.jpg'
import img24 from '../EquipoMedico/img24.jpg'
import img25 from '../EquipoMedico/img25.jpg'
import img26 from '../EquipoMedico/img26.jpg'
import img27 from '../EquipoMedico/img27.jpg'
import img28 from '../EquipoMedico/img28.jpg'
import img29 from '../EquipoMedico/img29.jpg'
import img30 from '../EquipoMedico/img30.jpg'
import img31 from '../EquipoMedico/img31.jpg'
import img32 from '../EquipoMedico/img32.jpg'
import img33 from '../EquipoMedico/img33.jpg'
import img34 from '../EquipoMedico/img34.jpg'
import img35 from '../EquipoMedico/img35.jpg'
import img36 from '../EquipoMedico/img36.jpg'
import img37 from '../EquipoMedico/img37.jpg'
import img38 from '../EquipoMedico/img38.jpg'
import img39 from '../EquipoMedico/img39.jpg'
import img40 from '../EquipoMedico/img40.jpg'
import img41 from '../EquipoMedico/img41.jpg'

export class MedicalInput2 extends Component {
    render() {
        return (
            <div>
                <Header />
                <Container>
                    <br />
                    <h1 className='text-center'>Medical Supplies</h1>
                    <br />
                    <Pagination className="justify-content-center" size="lg">
                        <Pagination.Item href="/en/MedicalInput">{1}</Pagination.Item>
                        <Pagination.Item active>{2}</Pagination.Item>
                        <Pagination.Item href="/en/MedicalInput3">{3}</Pagination.Item>
                    </Pagination>
                    <br />

                    <Row xs={1} md={2} className="g-4">
                        
                        {/* Producto 18 */}
                        <Col>
                            <Card className="h-100">
                                <Card.Header><h5>Disposable products</h5></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col>
                                            <Card.Title className="color-texto">Silk tape</Card.Title>
                                            <Card.Text>
                                                1/2" x 10 yards (24 rolls/box)<br />
                                                1" x 10 yards (12 rolls/box)<br />
                                                2" x 10 yards (6 rolls/box)<br />
                                                48 boxes/carton<br />
                                                Dimensions: 44 x 32.5 x 33.5 cm
                                            </Card.Text>
                                        </Col>
                                        <Col><Card.Img variant="top" src={img18} /></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Producto 23 */}
                        <Col>
                            <Card className="h-100">
                                <Card.Header><h5>Disposable products</h5></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col>
                                            <Card.Title className="color-texto">Micropore Tape</Card.Title>
                                            <Card.Text>
                                                1.25 cm x 10 yards (24 rolls/box)<br />
                                                2.5 cm x 10 yards (12 rolls/box)<br />
                                                5.0 cm x 10 yards (6 rolls/box)<br />
                                                7.5 cm x 10 yards<br />
                                                48 boxes/carton
                                            </Card.Text>
                                        </Col>
                                        <Col><Card.Img variant="top" src={img23} /></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Producto 24 */}
                        <Col>
                            <Card className="h-100">
                                <Card.Header><h5>Disposable products</h5></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col><Card.Title className="color-texto">Face Masks</Card.Title></Col>
                                        <Col><Card.Img variant="top" src={img24} /></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Producto 25 */}
                        <Col>
                            <Card className="h-100">
                                <Card.Header><h5>Disposable products</h5></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col><Card.Title className="color-texto">Scalp Vein Sets</Card.Title></Col>
                                        <Col><Card.Img variant="top" src={img25} /></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Producto 26 */}
                        <Col>
                            <Card className="h-100">
                                <Card.Header><h5>Disposable products</h5></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col>
                                            <Card.Title className="color-texto">Urine Bags</Card.Title>
                                            <Card.Text>Pediatric use</Card.Text>
                                        </Col>
                                        <Col><Card.Img variant="top" src={img26} /></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Producto 27 */}
                        <Col>
                            <Card className="h-100">
                                <Card.Header><h5>Disposable products</h5></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col>
                                            <Card.Title className="color-texto">Surgical Scrubs</Card.Title>
                                            <Card.Text>Disposable, variety of colors</Card.Text>
                                        </Col>
                                        <Col><Card.Img variant="top" src={img27} /></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Producto 28 */}
                        <Col>
                            <Card className="h-100">
                                <Card.Header><h5>Disposable products</h5></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col>
                                            <Card.Title className="color-texto">Surgical Gowns</Card.Title>
                                            <Card.Text>Disposable, variety of colors</Card.Text>
                                        </Col>
                                        <Col><Card.Img variant="top" src={img28} /></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Producto 29 */}
                        <Col>
                            <Card className="h-100">
                                <Card.Header><h5>Disposable products</h5></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col><Card.Title className="color-texto">Stomach Tube</Card.Title></Col>
                                        <Col><Card.Img variant="top" src={img29} /></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Producto 30 */}
                        <Col>
                            <Card className="h-100">
                                <Card.Header><h5>Disposable products</h5></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col><Card.Title className="color-texto">Foley Catheter</Card.Title></Col>
                                        <Col><Card.Img variant="top" src={img30} /></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Producto 31 */}
                        <Col>
                            <Card className="h-100">
                                <Card.Header><h5>Disposable products</h5></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col><Card.Title className="color-texto">Levin Catheter</Card.Title></Col>
                                        <Col><Card.Img variant="top" src={img31} /></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Producto 32 */}
                        <Col>
                            <Card className="h-100">
                                <Card.Header><h5>Disposable products</h5></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col><Card.Title className="color-texto">Foley Catheter (2-Way/3-Way)</Card.Title></Col>
                                        <Col><Card.Img variant="top" src={img32} /></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Producto 33 */}
                        <Col>
                            <Card className="h-100">
                                <Card.Header><h5>Disposable products</h5></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col><Card.Title className="color-texto">Nelaton Catheter</Card.Title></Col>
                                        <Col><Card.Img variant="top" src={img33} /></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Producto 34 */}
                        <Col>
                            <Card className="h-100">
                                <Card.Header><h5>Disposable products</h5></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col><Card.Title className="color-texto">Rectal Catheter</Card.Title></Col>
                                        <Col><Card.Img variant="top" src={img34} /></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Producto 35 */}
                        <Col>
                            <Card className="h-100">
                                <Card.Header><h5>Disposable products</h5></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col><Card.Title className="color-texto">Stomach Catheters</Card.Title></Col>
                                        <Col><Card.Img variant="top" src={img35} /></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Producto 36 */}
                        <Col>
                            <Card className="h-100">
                                <Card.Header><h5>Disposable products</h5></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col>
                                            <Card.Title className="color-texto">Endotracheal Tubes</Card.Title>
                                            <Card.Text>Variety of sizes and styles</Card.Text>
                                        </Col>
                                        <Col><Card.Img variant="top" src={img36} /></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Producto 37 */}
                        <Col>
                            <Card className="h-100">
                                <Card.Header><h5>Disposable products</h5></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col>
                                            <Card.Title className="color-texto">Endotracheal Tubes (Cuffed)</Card.Title>
                                            <Card.Text>Variety of sizes</Card.Text>
                                        </Col>
                                        <Col><Card.Img variant="top" src={img37} /></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Producto 38 */}
                        <Col>
                            <Card className="h-100">
                                <Card.Header><h5>Disposable products</h5></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col>
                                            <Card.Title className="color-texto">IV Administration Set</Card.Title>
                                            <Card.Text>Vented with "Y" site</Card.Text>
                                        </Col>
                                        <Col><Card.Img variant="top" src={img38} /></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Producto 39 */}
                        <Col>
                            <Card className="h-100">
                                <Card.Header><h5>Disposable products</h5></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col><Card.Title className="color-texto">Disposable Syringes</Card.Title></Col>
                                        <Col><Card.Img variant="top" src={img39} /></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Producto 40 */}
                        <Col>
                            <Card className="h-100">
                                <Card.Header><h5>Disposable products</h5></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col><Card.Title className="color-texto">Disposable Gloves</Card.Title></Col>
                                        <Col><Card.Img variant="top" src={img40} /></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Producto 41 */}
                        <Col>
                            <Card className="h-100">
                                <Card.Header><h5>Disposable products</h5></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col>
                                            <Card.Title className="color-texto">Wooden Swabs</Card.Title>
                                            <Card.Text>Bag of 100 Units</Card.Text>
                                        </Col>
                                        <Col><Card.Img variant="top" src={img41} /></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>
                    <br />

                    <Pagination className="justify-content-center" size="lg">
                        <Pagination.Item href="/en/MedicalInput">{1}</Pagination.Item>
                        <Pagination.Item active>{2}</Pagination.Item>
                        <Pagination.Item href="/en/MedicalInput3">{3}</Pagination.Item>
                    </Pagination>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}